module.exports = __webpack_public_path__ + "img/baleno-glx-deep-blue.a665b3da.png";